// Shared copy for the race-reminder text notifications, so sign-up and the
// profile page explain the phone number the same way.
export const PHONE_TIP = "This is only used for notifying you that your round or race is coming up.";
export const NO_REMINDERS_LABEL = "I don't want to be notified when my race is coming up";
